import http from '@core/fetch'
/**
 * 获取七牛资源详细信息方法
 *
 * sourcePath：string （资源路径）
 * params：string  （访问资源所需参数）
 */

export const getSourceInfo = async (sourcePath, params = 'imageInfo') => {
  const data = await http(`${sourcePath}`, {
    credentials: 'omit',
    dataType: 'json'
  })
  return data
}
